var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-page"},[_c('van-image',{staticClass:"bg",attrs:{"width":"237","height":"167","src":_vm.noCompanyBg}}),_c('div',{staticClass:"text"},[_vm._v("您当前暂无融资记录")]),_c('div',{staticClass:"btn",on:{"click":_vm.handleToBorrow}},[_vm._v("去融一笔")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }